import type { SVGProps } from 'react';

/**
 * The page editor's icon set: one 16px grid, 1.5 stroke, round joins, drawn for this
 * console (it has no icon library). Decorative by default; give a meaningful one a label.
 */
type IconProps = SVGProps<SVGSVGElement>;

function Icon({ children, ...rest }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconChevron = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6 3.5 10.5 8 6 12.5" />
  </Icon>
);
export const IconExternal = (p: IconProps) => (
  <Icon {...p}>
    <path d="M9.5 2.5h4v4M13.5 2.5 7.5 8.5M12 9.5v3a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3" />
  </Icon>
);
export const IconDesktop = (p: IconProps) => (
  <Icon {...p}>
    <rect x="1.75" y="2.5" width="12.5" height="8.5" rx="1" />
    <path d="M5.5 13.5h5M8 11v2.5" />
  </Icon>
);
export const IconPhone = (p: IconProps) => (
  <Icon {...p}>
    <rect x="4.25" y="1.5" width="7.5" height="13" rx="1.5" />
    <path d="M7.25 12.25h1.5" />
  </Icon>
);
export const IconShared = (p: IconProps) => (
  <Icon {...p}>
    <rect x="1.75" y="4.75" width="8" height="8.5" rx="1" />
    <path d="M6.25 2.75h7a1 1 0 0 1 1 1v7.5" />
  </Icon>
);
export const IconLock = (p: IconProps) => (
  <Icon {...p}>
    <rect x="3" y="7" width="10" height="7" rx="1" />
    <path d="M5.25 7V5a2.75 2.75 0 0 1 5.5 0v2" />
  </Icon>
);
export const IconList = (p: IconProps) => (
  <Icon {...p}>
    <path d="M5.5 4h8M5.5 8h8M5.5 12h8" />
    <circle cx="2.5" cy="4" r=".5" fill="currentColor" />
    <circle cx="2.5" cy="8" r=".5" fill="currentColor" />
    <circle cx="2.5" cy="12" r=".5" fill="currentColor" />
  </Icon>
);
export const IconSettings = (p: IconProps) => (
  <Icon {...p}>
    <path d="M2.5 4.5h6M11.5 4.5h2M2.5 11.5h2M7.5 11.5h6" />
    <circle cx="10" cy="4.5" r="1.5" />
    <circle cx="6" cy="11.5" r="1.5" />
  </Icon>
);
export const IconSearch = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="7" cy="7" r="4.25" />
    <path d="m10.25 10.25 3.25 3.25" />
  </Icon>
);
export const IconPlus = (p: IconProps) => (
  <Icon {...p}>
    <path d="M8 3v10M3 8h10" />
  </Icon>
);
export const IconClose = (p: IconProps) => (
  <Icon {...p}>
    <path d="m4 4 8 8M12 4l-8 8" />
  </Icon>
);
export const IconMenu = (p: IconProps) => (
  <Icon {...p}>
    <path d="M2.5 4h11M2.5 8h11M2.5 12h11" />
  </Icon>
);
export const IconHome = (p: IconProps) => (
  <Icon {...p}>
    <path d="M2.5 7.25 8 2.75l5.5 4.5V13a.5.5 0 0 1-.5.5h-3.25V10h-3.5v3.5H3a.5.5 0 0 1-.5-.5Z" />
  </Icon>
);
